import { render, staticRenderFns } from "./Psychologist.vue?vue&type=template&id=0fb7c447&scoped=true&"
import script from "./Psychologist.vue?vue&type=script&lang=js&"
export * from "./Psychologist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb7c447",
  null
  
)

export default component.exports